import * as yup from 'yup'
import axios from 'axios'
import debounce from 'debounce-promise'
import { isBlockedDomain } from '../common/isBlockedDomain'
import {
    findFlagByDialCode,
    searchFlag,
} from 'country-list-with-dial-code-and-flag'

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.{8,})/

const workspaceRegex = /^[a-z|0-9|A-Z]*$/

function validateBlockedEmailDomains(value, testContext) {
    return (
        !isBlockedDomain(value) ||
        testContext.createError({
            path: testContext.path,
            message: {
                type: BLOCKED_EMAIL,
                message: 'Only corporate emails are allowed',
            },
        })
    )
}

const wsNotExists = async ws => {
    if (ws) {
        let {
            data: { exists },
        } = await axios.get(
            `${process.env.REACT_APP_AUTH_VERIFY_WORKSPACE_URL}/${ws}`
        )
        return !exists
    }
    return Promise.resolve(true)
}
const emailNotExists = async email => {
    if (email) {
        let {
            data: { exists },
        } = await axios.get(
            `${process.env.REACT_APP_AUTH_VERIFY_EMAIL_URL}/${email}`
        )
        return !exists
    }
    return Promise.resolve(true)
}
const wsNotExistsDebounce = debounce(wsNotExists, 1000)
const emailNotExistsDebounce = debounce(emailNotExists, 1000)
export const WS_CHECK_FAILURE = 'WS_CHECK_FAILURE'
const validateWsExists = async (value, testContext) => {
    try {
        return (
            (await wsNotExistsDebounce(value)) ||
            testContext.createError({
                path: testContext.path,
                message: {
                    type: 'WS_CHECK_FAILURE',
                    message: 'Workspace name already exists',
                },
            })
        )
    } catch (e) {
        return testContext.createError({
            path: testContext.path,
            message: {
                type: 'WS_CHECK_FAILURE',
                message:
                    'Something went wrong while checking the workpace. try again',
            },
        })
    }
}
export const EXISTING_EMAIL_CHECK_FAILED = 'EMAIL_EXISTING_CHECK_FAILURE'
const validateUserEmailExists = async (value, testContext) => {
    try {
        return (
            (await emailNotExistsDebounce(value)) ||
            testContext.createError({
                path: testContext.path,
                message: {
                    type: EXISTING_EMAIL_CHECK_FAILED,
                    message: 'Account with the same email ID already exists',
                },
            })
        )
    } catch (e) {
        return testContext.createError({
            path: testContext.path,
            message: {
                type: EXISTING_EMAIL_CHECK_FAILED,
                message:
                    'Something went wrong while checking the email. try again',
            },
        })
    }
}
export const BLOCKED_EMAIL = 'BLOCKED_EMAIL'
export const signupFormSchema = yup
    .object()
    .shape({
        first_name: yup
            .string()
            .required('First name cannot be empty')
            .trim()
            .default(''),
        workspace: yup
            .string()
            .required('Workspace name cannot be empty')
            .trim()
            .default('')
            .matches(workspaceRegex, 'Special characters are not allowed')
            .test(
                'ws-exists',
                'Workspace already exists, please try another name',
                validateWsExists
            ),
        last_name: yup
            .string()
            .required('Last name cannot be empty')
            .trim()
            .default(''),
        password: yup
            .string()
            .required('Password cannot be empty')
            .matches(
                passwordRegex,
                'Password should follow the password policy'
            )
            .default(''),
        email: yup
            .string()
            .required('Work email cannot be empty')
            .trim()
            .email('Work email must be a valid email')
            .test(
                'is-not-blocked-email',
                'only corporate emails are allowed',
                validateBlockedEmailDomains
            )
            .test('is-not-existed-in-server', validateUserEmailExists)
            .default(''),
        org: yup
            .string()
            .required('Company name cannot be empty')
            .trim()
            .default(''),
        company_size: yup
            .string()
            .required('Company size cannot be empty')
            .trim()
            .default(''),
        phone_code: yup
            .object({
                dialog_code: yup.string(),
                flag: yup.string(),
            })
            .nullable()
            .required('Country code cannot be empty')
            .default({
                dial_code: '+1',
                flag: findFlagByDialCode('+1').flag,
            }),
        phone_number: yup
            .string()
            .required('Phone number cannot be empty')
            .trim()
            .default(''),
        country: yup
            .object({
                name: yup.string(),
                code: yup.string(),
                flag: yup.string(),
            })
            .nullable()
            .required('You must choose the country!')
            .default(null),
        use_case: yup
            .string()
            .required('Use case cannot be empty')
            .trim()
            .default(''),
    })
    .strict(false)
